module.exports = __webpack_public_path__ + "static/media/iStock-1093850372.f6a2f805.jpg";